import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const profilePageBreadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.profile.breadcrumb.profile_label1'),
  },
];
